import { TranslateService } from '@ngx-translate/core';
import { SelectOption } from '@/core/types/angular-primeng-api';
import { CloneUtils } from '@/core/utils/clone-utils';
import { TimeFormat } from '@/core/models/time-format';

export class DefaultDateFormatListService {
    constructor() {}

    public static getTranslatedTimeFormats(translateService: TranslateService): SelectOption<TimeFormat>[] {
        const formats = CloneUtils.cloneData(this.getTimeFormats());
        formats.forEach((format) => {
            format.name = translateService.instant(format.name);
        });
        return formats;
    }

    public static getTimeFormats(): SelectOption<TimeFormat>[] {
        return [
            { code: 'HH:mm', name: 'profile_time_HH_mm' },
            { code: 'hh:mm A', name: 'profile_time_h_mma' },
        ];
    }

    public static getDefaultTimeFormat(): TimeFormat {
        return this.getTimeFormats()[0].code;
    }

    public static getDateFormats(): SelectOption[] {
        return [
            { name: 'DD.MM.YYYY', code: 'DD.MM.YYYY' },
            { name: 'DD/MM/YYYY', code: 'DD/MM/YYYY' },
            { name: 'MM/DD/YYYY', code: 'MM/DD/YYYY' },
            { name: 'YYYY/MM/DD', code: 'YYYY/MM/DD' },
            { name: 'YYYY.MM.DD', code: 'YYYY.MM.DD' },
            { name: 'YYYY-MM-DD', code: 'YYYY-MM-DD' },
        ];
    }

    public static getDefaultDateFormat(): string {
        return this.getDateFormats()[0].code;
    }

    public static getDurationFormats(): SelectOption[] {
        return [
            { name: 'HH:mm:ss', code: 'HH:mm:ss' },
            { name: 'Decimal', code: 'Decimal' },
        ];
    }

    public static getDefaultDurationFormat(): string {
        return this.getDurationFormats()[0].code;
    }
}
